import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, StyleSheet, Platform } from 'react-native';
import { MainColors } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';

const FormTextInput = (props) => {
    const [isFocused, setIsFocused] = useState(false);
    const [heightForWeb, setHeightForWeb] = useState();

    useEffect(() => {
        getTextInputHeightForWebPlatform();
    }, []);

    const getTextInputHeightForWebPlatform = () => {
        if (Platform.OS === 'web' && props.multiline) {
            setHeightForWeb(100);
        } else {
            setHeightForWeb();
        }
    }

    return (
        <View style={styles.container}>
            <Text style={[styles.label, isFocused ? styles.focusedLabel : styles.unFocusedLabel]}>
                {props.label}
            </Text>

            <TextInput
                style={[styles.textInput, isFocused ? styles.focusedInput : styles.unfocusedInput, { minHeight: heightForWeb }]}
                selectionColor={MainColors.primary}
                placeholderTextColor={MainColors.lightGray}
                placeholder={props.placeholder}
                value={props.value}
                onChangeText={props.onChangeText}
                accessibilityLabel={props.accessibilityLabel}
                accessibilityHint={props.accessibilityHint}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onSubmitEditing={props.onSubmitEditing}
                editable={props.editable}
                multiline={props.multiline}
                secureTextEntry={props.secureTextEntry}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 30
    },
    label: {
        fontSize: FontSizes.medium,
        marginBottom: 8,
        paddingLeft: 12,
        fontWeight: '500'
    },
    focusedLabel: {
        color: MainColors.primary,
        borderBottomColor: MainColors.primary
    },
    unFocusedLabel: {
        color: MainColors.mediumGray,
    },
    focusedInput: {
        borderBottomColor: MainColors.primary,
        borderBottomWidth: 2
    },
    unfocusedInput: {
        borderBottomColor: MainColors.lightGray,
        borderBottomWidth: 1
    },
    textInput: {
        fontSize: FontSizes.medium,
        paddingBottom: 8,
        paddingLeft: 12
    }
});

export default FormTextInput;